import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postService } from '../services/api';
// import getOptimalAdRoute from '../utils/AdRouter';
import '../styles/Home.css';
import NativeBanner from '../components/NativeBanner';
import PopUnderAd from '../components/PopUnderAd';
import SearchBar from '../components/SearchBar';

const SearchResults = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const query = searchParams.get('q');

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (query) {
            searchPosts();
        }
    }, [query]);

    const searchPosts = async () => {
        try {
            setLoading(true);
            const data = await postService.searchPosts(query);
            setPosts(data.posts);
            setError('');
        } catch (err) {
            setError('Failed to search posts.');
            console.error('Error searching:', err);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const truncateText = (text, maxLength = 200) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    if (loading) {
        return (
            <div className="home-container">
                <div className="loading">Searching...</div>
            </div>
        );
    }

    return (
        <div className="home-container">
            <PopUnderAd />

            <div className="home-header">
                <h1>Search Results for "{query}"</h1>
                <p>{posts.length} post{posts.length !== 1 ? 's' : ''} found</p>
            </div>
            <div className='search-bar-container'>
                <SearchBar />
            </div>
            {posts.length === 0 ? (
                <div className="no-posts">
                    <p>No posts found for "{query}". Try a different search term.</p>
                </div>
            ) : (
                <div className="posts-grid">
                    {posts.map((post) => (
                        <div
                            key={post._id}
                            onClick={() => {
                                window.open('https://www.profitableratecpmnetwork.com/p30hpe5v?key=308e8f6fbe3fe7839661a714c9301acf', '_blank');
                                // const route = getOptimalAdRoute(post._id);
                                // navigate(route);
                                navigate(`/post/${post._id}`);
                            }}
                            className="post-card"
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="post-card-content">
                                <h2 className="post-title">{post.title}</h2>
                                <p className="post-excerpt">{truncateText(post.body)}</p>
                                <div className="post-meta">
                                    <span className="post-author">
                                        ✍️ {post.author?.username || 'Anonymous'}
                                    </span>
                                    <span className="post-date">
                                        📅 {formatDate(post.createdAt)}
                                    </span>
                                    <span className="post-views">
                                        👁️ {post.views} views
                                    </span>
                                </div>
                            </div>
                            <div className="post-card-footer">
                                <span className="read-more">Read More →</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <NativeBanner />
        </div>
    );
};

export default SearchResults;